/* SHIFT */
export const TEAM_MEMBERS_LIST = 'TEAM_MEMBERS_LIST';
export const TEAM_MEMBERS_LIST_SUCCESS = 'TEAM_MEMBERS_LIST_SUCCESS';
export const TEAM_MEMBERS_LIST_FAILED = 'TEAM_MEMBERS_LIST_FAILED';

export const SHIFT_CREATE = 'SHIFT_CREATE';
export const SHIFT_CREATE_SUCCESS = 'SHIFT_CREATE_SUCCESS';
export const SHIFT_CREATE_FAILED = 'SHIFT_CREATE_FAILED';

export const GET_WEEKS_LIST = 'GET_WEEKS_LIST';
export const GET_WEEKS_LIST_SUCCESS = 'GET_WEEKS_LIST_SUCCESS';
export const GET_WEEKS_LIST_FAILED = 'GET_WEEKS_LIST_FAILED';

export const GET_PREVIOUS_SHIFT = 'GET_PREVIOUS_SHIFT';
export const GET_PREVIOUS_SHIFT_SUCCESS = 'GET_PREVIOUS_SHIFT_SUCCESS';
export const GET_PREVIOUS_SHIFT_FAILED = 'GET_PREVIOUS_SHIFT_FAILED';

export const SHIFT_EDIT = 'SHIFT_EDIT';
export const SHIFT_EDIT_SUCCESS = 'SHIFT_EDIT_SUCCESS';
export const SHIFT_EDIT_FAILED = 'SHIFT_EDIT_FAILED';

export const SHIFT_SWAP = 'SHIFT_SWAP';
export const SHIFT_SWAP_SUCCESS = 'SHIFT_SWAP_SUCCESS';
export const SHIFT_SWAP_FAILED = 'SHIFT_SWAP_FAILED';


export const FIRST_SHIFT_EDIT = 'FIRST_SHIFT_EDIT';
export const FIRST_SHIFT_EDIT_SUCCESS = 'FIRST_SHIFT_EDIT_SUCCESS';
export const FIRST_SHIFT_EDIT_FAILED = 'FIRST_SHIFT_EDIT_FAILED';

export const FIRST_SHIFT_SWAP = 'FIRST_SHIFT_SWAP';
export const FIRST_SHIFT_SWAP_SUCCESS = 'FIRST_SHIFT_SWAP_SUCCESS';
export const FIRST_SHIFT_SWAP_FAILED = 'FIRST_SHIFT_SWAP_FAILED';


export const SWAP_DELETE = 'SWAP_DELETE';
export const SWAP_DELETE_SUCCESS = 'SWAP_DELETE_SUCCESS';
export const SWAP_DELETE_FAILED = 'SWAP_DELETE_FAILED';

export const SHIFT_LIST = 'SHIFT_LIST';
export const SHIFT_LIST_SUCCESS = 'SHIFT_LIST_SUCCESS';
export const SHIFT_LIST_FAILED = 'SHIFT_LIST_FAILED';


export const SHIFT_ADD = 'SHIFT_ADD';
export const SHIFT_ADD_SUCCESS = 'SHIFT_ADD_SUCCESS';
export const SHIFT_ADD_FAILED = 'SHIFTADD_ADD_FAILED';

export const SHIFT_UPDATE = 'SHIFT_UPDATE';
export const SHIFT_UPDATE_SUCCESS = 'SHIFT_UPDATE_SUCCESS';
export const SHIFT_UPDATE_FAILED = 'SHIFT_UPDATE_FAILED';

export const SHIFT_DELETE = 'SHIFT_DELETE';
export const SHIFT_DELETE_SUCCESS = 'SHIFT_DELETE_SUCCESS';
export const SHIFT_DELETE_FAILED = 'SHIFTADD_DELETE_FAILED';


export const SHIFT_COMMENT_EDIT = 'SHIFT_COMMENT_EDIT';
export const SHIFT_COMMENT_EDIT_SUCCESS = 'SHIFT_COMMENT_EDIT_SUCCESS';
export const SHIFT_COMMENT_EDIT_FAILED = 'SHIFT_COMMENT_EDIT_FAILED';

export const SHIFT_PREVIEW = 'SHIFT_PREVIEW';
export const SHIFT_PREVIEW_SUCCESS = 'SHIFT_PREVIEW_SUCCESS';
export const SHIFT_PREVIEW_FAILED = 'SHIFT_PREVIEW_FAILED';
